<template>
  <b-modal
      id="upload-photo-modal"
      title="Upload Photo & Note"
      @hide="reset"
      @show="fetchUploadedPhotos"
      ok-only
      ok-title="Close"
  >
    <b-form-group label="Photo">
      <input
          type="file"
          ref="fileInput"
          accept="image/*"
          @change="onFileChange"
          style="display: none;"
      >

      <button class="btn btn-outline-primary btn-sm w-100" @click="$refs.fileInput.click()">
        {{ photo ? 'Change Photo' : 'Choose Photo' }}
      </button>


      <div v-if="photo" class="mt-2">
        <small class="text-success">{{ photo.name }}</small>
      </div>

    </b-form-group>

    <b-form-group label="Note">
      <b-form-textarea
          v-model="note"
          rows="3"
          placeholder="Add a note about the photo..."
      ></b-form-textarea>
      <small v-if="note && !noteIsValid" class="text-danger">
        Please enter at least 3 words.
      </small>
    </b-form-group>

    <div class="d-flex justify-content-end">
      <button
          class="btn btn-primary"
          :disabled="!photo || !noteIsValid"
          @click="uploadPhoto"
      >
        Upload
      </button>
    </div>

    <div v-if="uploaded.length" class="mt-4">
      <label>Uploaded Photos</label>
      <div class="card-grid grid-col-2 grid-col-md-3">
        <image-item
            v-for="(img, index) in uploadedWithTitles"
            :key="index"
            imageType="general"
            :imageData="img.path"
            :title="img.displayTitle"
        />
      </div>
    </div>
  </b-modal>
</template>

<script>
import Compressor from 'compressorjs';

export default {
  props: {
    deviceId: {
      type: [String, Number],
      required: true
    }
  },

  data() {
    return {
      photo: null,
      note: '',
      uploaded: []
    };
  },

  computed: {
    noteIsValid() {
      if (!this.note) return false;
      return this.note.trim().split(/\s+/).filter(Boolean).length >= 3;
    },
    uploadedWithTitles() {
      return this.uploaded.map(img => ({
        ...img,
        displayTitle: img.notes && img.notes.length > 0
            ? img.notes[0].content
            : 'General Photos'
      }));
    }
  },

  methods: {
    uploadPhoto() {
      if (!this.photo) {
        this.$store.dispatch('displayToast', { text: 'No file selected.', type: 'error' });
        return;
      }

      new Compressor(this.photo, {
        quality: 0.6,
        success: compressed => {
          const formData = new FormData();
          formData.append('image', compressed);
          formData.set('device_id', this.deviceId);
          formData.set('type', 'general');
          if (this.note) {
            formData.set('note', this.note);
          }

          this.$store.dispatch('displayToast', { text: 'Uploading photo...', type: 'info' });

          this.$http.post(`/api/v4/images/store/${this.deviceId}`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
          }).then(({ data }) => {
            this.uploaded.push(data.data);
            this.photo = null;
            this.note = '';
            this.$store.dispatch('displayToast', {
              text: 'Photo uploaded successfully.',
              type: 'success'
            });
          }).catch(err => {
            const message = err?.response?.statusText || 'Upload failed';
            this.$store.dispatch('displayToast', { text: message, type: 'error' });
          });
        },
        error: () => {
          this.$store.dispatch('displayToast', { text: 'Could not process file.', type: 'error' });
        }
      });
    },

    fetchUploadedPhotos() {
      this.$http.get(`/api/v4/images/general/${this.deviceId}`)
          .then(({ data }) => {
            this.uploaded = data.data;
          })
          .catch(() => {
            this.$store.dispatch('displayToast', {
              text: 'Failed to fetch uploaded photos.',
              type: 'error'
            });
          });
    },

    reset() {
      this.photo = null;
      this.note = '';
      this.fetchUploadedPhotos(); // refresh uploaded photos on modal close
    },

    onFileChange(event) {
      this.photo = event.target.files[0] || null;
    }
  }
};
</script>
